<template>
  <div>
    <EditDialog></EditDialog>
    <b-list-group-item>
      <b-row>
        <b-col md="1">
          <i v-b-modal.modal-3 class="fa fa-edit mr-2" @click="setEdit()" />
          <i v-b-modal.modal-2 class="fa fa-trash" @click="setEdit()" />
        </b-col>
        <b-col sm="1">{{ contact.FirstName }}</b-col>
        <b-col sm="2">{{ contact.LastName }}</b-col>
        <b-col sm="2">{{ contact.Department }}</b-col>
        <b-col sm="2">{{ contact.Phone1 }}</b-col>
        <b-col sm="4">{{ contact.Email1 }}</b-col>
      </b-row>
    </b-list-group-item>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import EditDialog from "@/components/dialogs/EditDialog.vue";
export default {
  data() {
    return {
      public_contact: contact
    };
  },
  components: {
    StyledDialog,
    EditDialog
  },
  props: {
    contact: Object,
    isCompany: Boolean
  },
  computed: {
    ...mapActions("client", ["loadContactEdit"])
  },
  methods: {
    setEdit() {
      // if (this.isCompany) {
      //   this.$store.dispatch("client/loadCompanyLocationEdit", this.location);
      // } else {
      this.$store.dispatch("client/loadContactEdit", this.contact);
      //}
    },
    createFreshLocationObject() {
      return {
        Name: "Test"
      };
    }
  },
  mounted() {}
};
</script>

<style scoped>
.location-card {
  padding: 20px;
  margin-bottom: 24px;
  transition: all 0.2s linear;
  cursor: pointer;
}
.location-card:hover {
  transform: scale(1.01);
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2), 0 1px 15px 0 rgba(0, 0, 0, 0.19);
}
.location-card > .title {
  margin: 0;
}

.location-link {
  color: black;
  text-decoration: none;
  font-weight: 100;
}
</style>